import { createContext, useContext } from 'react';

const ComboboxContext = createContext(null);

export function useCombobox() {
  const context = useContext(ComboboxContext);
  if (!context) {
    throw new Error('Combobox compound components must be used within a <Combobox> provider');
  }
  return context;
}

export default ComboboxContext;
